import generic from '@/shared/utils/generic.js';

/// Sets component.elements configuration properties
///     that    : VueComponent
///     elsCnfg : Elements configurations
/// ************************************************
const setElementsConfig = function (that, elsCnfg) {
  that.elsLabel = elsCnfg.lstLabel;
  that.elsInUse = elsCnfg.lstInUse;
  that.elsRequired = elsCnfg.lstRequired;
  that.elsHelperText = elsCnfg.lstHelperText;
};

/// Returns true if language is English/ Primary 
/// Reads info from external input
/// *******************************
const isPrimaryLang = function () {
  if (window._inputs === undefined || window._inputs === null) console.log("window._inputs missing in isPrimaryLang");
  else return window._inputs.inputGlobal.locale.startsWith("en");
};

/// Returns local name from external input
/// Reads info from external input
/// ***************************
const getLocale = function () {
  if (window._inputs === undefined || window._inputs === null) console.log("window._inputs missing in getLocale");
  else return window._inputs.inputGlobal.locale;
};

/// Returns current currency symbol
/// Reads info from external input
/// *********************************
const currentCurrency = function () {
  if (window._inputs === undefined || window._inputs === null) console.log("window._inputs missing in currentCurrency");
  else return window._inputs.inputGlobal.currency;
};

/// Build URi for static asset
/// Reads info from external input
/// *******************************
const assetUri = function (asset) {
  if (window._inputs === undefined || window._inputs === null) console.log("window._inputs missing in assetUri");
  else return window._inputs.inputGlobal.assetsUri + asset;
};

/// Reads a text from configuration
/// *******************************************
const textValue = function (texts, cuInfo, params, refData, key, args) {
  if (!texts) return '';
  const text = texts.filter(el => { return el.Key === key; });
  let finalText = text.length > 0 ? (isPrimaryLang() ? text[0].Html : text[0].HtmlLang2) : '';

  try {
    if (window?._inputs?.inputModule) {
      const { inputModule } = window._inputs;
      const loanAmount = inputModule.loanAmount;
      const loanRepayment = inputModule.loanRepayment;
      const loanTerm = inputModule.loanTerm;

      finalText = finalText.replaceAll("{LoanAmount}", generic.formatCurrencyToUi(loanAmount, currencyConfig()))
        .replaceAll("{RepaymentAmount}", generic.formatCurrencyToUi(loanRepayment, currencyConfig({ precision: 2 })))
        .replaceAll("{LoanTerm}", loanTerm);

      if (refData && (finalText.includes("{LoanFrequency}") || finalText.includes("{FrequencyText}"))) {
        const item = refData.Frequencies.find(el => el.ID == inputModule.loanFrequency);
        if (item) {
          finalText = finalText.replaceAll("{LoanFrequency}", item.Plural);
          finalText = finalText.replaceAll("{FrequencyText}", item.Value);
        }
      }
    }
  } catch (error) {
    alert(error);
    console.error("An error occurred while processing inputModule:", error);
    // Handle or log the error as needed
  }

  // Support for "CUInfo.*" and "Param." usage in texts
  if (cuInfo && finalText.indexOf("{CUInfo.") !== -1) Object.entries(cuInfo).forEach(p => finalText = finalText.replaceAll("{CUInfo." + p[0] + "}", p[1]));
  if (params && finalText.indexOf("{Param.") !== -1) params.forEach(p => finalText = finalText.replaceAll("{Param." + p.Name + "}", p.Value));
  if (refData && finalText.indexOf("{Setting.") !== -1) refData.SystemSettings.forEach(p => finalText = finalText.replaceAll("{Setting." + p.Name + "}", p.Value));

  return args && Array.isArray(args) && args.length > 0 ? finalText.format(args) : finalText;
};

const clone = function (obj, bare) {
  if (bare) {
    let ret = {};
    Object.entries(obj).forEach(p => {
      ret[p[0]] = p[1] !== null && typeof p[1] === 'object' ? p[1].ID : p[1];
    });
    return ret;
  }
  else return JSON.parse(JSON.stringify(obj));
};

const currencyConfig = function (defaultOptions) {
  return {
    length: defaultOptions && defaultOptions.length ? defaultOptions.length : 7,
    precision: defaultOptions && defaultOptions.precision ? defaultOptions.precision : 0, 
    locale: getLocale(),
    prefix: currentCurrency()
  };
};

export default {
  setElementsConfig, 
  isPrimaryLang, 
  textValue,
  currentCurrency, 
  getLocale, 
  assetUri,
  currencyConfig, 
  clone
};
